import { gql } from '@apollo/client';

export const REMOVE_PERSON_ALERT = gql`
  mutation removePersonAlert($input: RemovePersonAlertInput!) {
    removePersonAlert(input: $input) {
      errors
    }
  }
`


